<template>
  <div>
    <div class="des">{{$t('NoPermission')}}</div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.des {
  font-size: 14px;
  text-align: center;
  padding-top: 120px;
  color: #666;
}
</style>